import { render, staticRenderFns } from "./BrokerPreRegister.vue?vue&type=template&id=138a9fde"
import script from "./BrokerPreRegister.vue?vue&type=script&lang=js"
export * from "./BrokerPreRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports